import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Plus, Globe, Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const Pricing = () => (
  <section id="precos" className="py-24 border-t border-warmz-glass-border/20">
    <div className="container mx-auto px-4 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">
          Comece grátis. Pague apenas quando <span className="gradient-text-fire">precisar escalar.</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {/* Starter Card */}
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="glass-card gradient-border p-8 flex flex-col relative"
        >
          <Badge className="absolute -top-3 left-6 bg-warmz-green-bright text-warmz-bg font-bold px-3 py-1 text-xs">
            <Sparkles size={12} className="mr-1" />
            7 Dias Grátis
          </Badge>

          <span className="text-xs uppercase tracking-widest text-primary font-semibold mb-3 mt-2">
            Plano Starter
          </span>
          <div className="flex items-end gap-1 mb-2">
            <span className="font-display text-5xl font-bold text-foreground">$19</span>
            <span className="text-muted-foreground text-sm mb-1">/mês</span>
          </div>
          <p className="text-xs text-muted-foreground mb-6">
            7 dias grátis para testar. Cancele a qualquer momento.
          </p>

          <ul className="space-y-3 mb-8 flex-1">
            {[
              "2 Números Inclusos",
              "Simulação Multimédia Completa",
              "Stories Automáticos",
              "Grupos de Aquecimento",
              "Gestão de Grupos Próprios",
              "Agenda de Contatos com Tags",
              "Contatos Oficiais Verificados",
              "Perfis de Aquecimento Customizáveis",
              "Esteira de Fases Automática",
              "Suporte Prioritário",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3 text-sm text-secondary-foreground">
                <Check className="text-warmz-green-bright shrink-0" size={16} />
                {item}
              </li>
            ))}
          </ul>
          <p className="text-[11px] text-muted-foreground mb-4 -mt-4">
            * No trial de 7 dias você pode adicionar até +3 números extras gratuitamente (total de 5). Após o trial, cada número extra custa $9/mês.
          </p>

          <Link
            to="/signup"
            className="block text-center px-6 py-3.5 rounded-xl bg-primary text-primary-foreground font-bold glow-orange transition-transform hover:scale-105"
          >
            Testar Grátis por 7 Dias
          </Link>
        </motion.div>

        {/* Add-ons Card */}
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="glass-card p-8 flex flex-col"
        >
          <span className="text-xs uppercase tracking-widest text-warmz-green-bright font-semibold mb-3">
            Add-ons Modulares
          </span>
          <p className="text-muted-foreground text-sm mb-8">
            Monte o plano ideal para a sua operação — como blocos de montar. O trial já inclui 5 números.
          </p>

          <div className="space-y-5 flex-1">
            {/* Add-on 1 */}
            <div className="flex items-center gap-4 p-4 rounded-xl bg-secondary/50 border border-warmz-glass-border/30">
              <div className="w-10 h-10 rounded-lg bg-primary/15 flex items-center justify-center">
                <Plus className="text-primary" size={18} />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-foreground">Número Extra</p>
                <p className="text-xs text-muted-foreground">Adicione mais chips ao seu plano</p>
              </div>
              <span className="font-display text-lg font-bold text-foreground">$9<span className="text-xs text-muted-foreground">/mês</span></span>
            </div>

            {/* Add-on 2 */}
            <div className="flex items-center gap-4 p-4 rounded-xl bg-secondary/50 border border-warmz-glass-border/30 opacity-50">
              <div className="w-10 h-10 rounded-lg bg-accent/15 flex items-center justify-center">
                <Globe className="text-accent" size={18} />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-semibold text-foreground">Rede Global</p>
                  <Badge variant="outline" className="text-[10px] border-warmz-glass-border/50">Em breve</Badge>
                </div>
                <p className="text-xs text-muted-foreground">Blindagem máxima por chip</p>
              </div>
              <span className="font-display text-lg font-bold text-foreground">$5<span className="text-xs text-muted-foreground">/mês</span></span>
            </div>
          </div>

          <Link
            to="/signup"
            className="mt-8 block text-center px-6 py-3.5 rounded-xl border border-warmz-glass-border text-foreground font-semibold hover:bg-secondary/60 transition-colors"
          >
            Personalizar Plano
          </Link>
        </motion.div>
      </div>
    </div>
  </section>
);

export default Pricing;
